var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal_history_call" },
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.globalLoadingColor },
      }),
      _vm._v(" "),
      _vm.localCalls.length || _vm.allCalls.length
        ? _c("div", [
            _c("h6", { staticClass: "m-0" }, [_vm._v("История звонков")]),
            _vm._v(" "),
            _vm.totalExtraCalls
              ? _c("div", { staticClass: "text-right" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.showAll,
                        expression: "showAll",
                      },
                    ],
                    attrs: { type: "checkbox", name: "", id: "ch_11" },
                    domProps: {
                      checked: Array.isArray(_vm.showAll)
                        ? _vm._i(_vm.showAll, null) > -1
                        : _vm.showAll,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.showAll,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.showAll = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.showAll = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.showAll = $$c
                          }
                        },
                        _vm.updateList,
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "pointer", attrs: { for: "ch_11" } },
                    [_vm._v("Показать все звонки по клиенту")]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { class: { short_list: _vm.longList && !_vm.showFullList } },
              _vm._l(_vm.getCallsList(), function (call) {
                return _c(
                  "div",
                  {
                    key: call.id,
                    class: {
                      "card p-2 overflow-hidden": true,
                      "text-muted": call.call_duration < 15,
                    },
                  },
                  [
                    call.call_duration < 15
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "corner-ribbon top-right sticky gray shadow",
                          },
                          [_vm._v("\n          без ответа\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        call?.user
                          ? [
                              _c("span", [
                                _vm._v("(" + _vm._s(call.user_id) + ") "),
                                call.user
                                  ? _c("span", [_vm._v(_vm._s(call.user.name))])
                                  : _vm._e(),
                              ]),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-muted" }, [
                          _vm._v(
                            _vm._s(
                              _vm.printDate(call.created_at, "DD.MM.YYYY HH:mm")
                            ) +
                              " (" +
                              _vm._s(call.id) +
                              ")"
                          ),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", [
                      call.notOrder
                        ? _c(
                            "span",
                            { staticClass: "badge badge-dark valign-top" },
                            [_vm._v("другой звонок")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("i", {
                        class: {
                          "icon-fa": true,
                          "icon-fa-arrow-circle-left green": call.type_id === 1,
                          "icon-fa-arrow-circle-right blue": call.type_id === 2,
                        },
                      }),
                      _vm._v(
                        "\n          " +
                          _vm._s(call.phone_title || "не определен") +
                          " =>\n          " +
                          _vm._s(call.destination || "не определен") +
                          "\n          "
                      ),
                      _c(
                        "span",
                        { staticClass: "badge badge-info valign-top" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                call.ip_phone && call.ip_phone.description
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      !call.file_link
                        ? _c("span", [
                            _c("strong", [
                              _vm._v(_vm._s(call.call_duration) + "c."),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      call.status && +call.status !== 1
                        ? _c(
                            "span",
                            { staticClass: "valign-top badge badge-success" },
                            [_vm._v("A " + _vm._s(call.status))]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    call.file_link
                      ? _c("audio", { attrs: { controls: "" } }, [
                          _c("source", {
                            attrs: {
                              src: `https://admin.rancond.info/api/noa/mangoRecord/${call.id}`,
                              type: "audio/mpeg",
                            },
                          }),
                          _vm._v(
                            "\n          Your browser does not support the audio tag.\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.longList
              ? _c("div", [
                  _c(
                    "span",
                    {
                      staticClass: "pointer underline",
                      on: {
                        click: function ($event) {
                          _vm.showFullList = !_vm.showFullList
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.showFullList ? "Скрыть" : "Показать все")
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }